import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateVenueCategory } from 'src/api/updateVenueCategory/updateVenueCategory';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';
import type { TUpdateVenueCategory } from 'src/api/updateVenueCategory';

export const useUpdateVenueCategory = () => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    async ({ categoryId, newDisplayOrder, newParentId, newName }: TUpdateVenueCategory) =>
      updateVenueCategory({
        categoryId,
        newDisplayOrder,
        newParentId,
        newName,
      }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.venueCategories] });
      },
      onError: () => {
        showSnackbar({
          status: SnackbarStatus.ERROR,
          message: 'We have been unable to complete your request',
        });
      },
    },
  );
};
